(function ($, Drupal) {
  $(document).ready(function() {


    if ($(window).width() < 960) {
      showMobile();
    }
    else {
      showDesktop();
    }

    $(window).resize(function () {
      if ($(window).width() < 960) {
        showMobile();
      }
      else {
        showDesktop();
      }
    });
  });

  function showDesktop() {
    var dh = $("#desktop-header");
    var mh = $("#mobile-header");

    if (dh) { dh.show(); }
    if (mh) { mh.hide(); }
  }

  function showMobile() {
    var dh = $("#desktop-header");
    var mh = $("#mobile-header");

    if (dh) { dh.hide(); }
    if (mh) { mh.show(); }
  }
})(jQuery, Drupal);